import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './App.css';
import { RECAPTCHA_SITE_KEY } from './config';
import HomePage from './pages/HomePage';
import InfoPage from './pages/InfoPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ProductSurveyPage from './pages/ProductSurveyPage';

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/info" element={<InfoPage />} />
          <Route path="/survey" element={<ProductSurveyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;
